<template>
	<div class="investment-owner p-3">
		<div class="d-flex justify-content-between">
			<h5 class="text">{{investment.name}}</h5>
			<a href="#" v-on:click.stop v-on:click.prevent="onEditClick">edit</a>
		</div>
		<div class="owners">
			<div>Associate: {{associates}}</div>
			<div>Verification: {{verifiers}}</div>
		</div>
	</div>
</template>

<script>
export default {
	name: "InvestmentOwner",
	props: ['investment'],
	emits: ['edit'],
	computed: {
		associates() {
			if (this.investment.uploaders && this.investment.uploaders.length > 0) {
				return this.investment.uploaders.map(u => u.name).join(', ')
			}
			return 'Not set'
		},
		verifiers() {
			if (this.investment.verifiers && this.investment.verifiers.length > 0) {
				return this.investment.verifiers.map(u => u.name).join(', ')
			}
			return 'Not set'
		}
	},
	methods: {
		onEditClick() {
			this.$emit('edit', this.investment)
		}
	}
}
</script>

<style lang="scss" scoped>
	h5 {
		font-weight: 400;
	}
	@import '../../styles/custom-variables';
	.investment-owner:nth-child(odd) {
		background-color: $zebra;
	}
	.owners {
		color: $graphite;
	}
</style>
